import {Component, OnInit} from '@angular/core';
import {DynamicDialogConfig, DynamicDialogRef} from "primeng/dynamicdialog";
import {InvoiceService} from "../../../../services/invoice.service";
import {Invoice} from "../../../../models/invoice";
import {NgxSpinnerService} from "ngx-spinner";
import {ToastService} from "../../../../services/toast.service";
import moment from "moment";

/**
 * EM-2910: mostra o último erro da integração da fatura com o financeiro (ERP) e reenvia a fatura
 * (PUT /api-orders/secure/invoice/{id}/update-programado).
 */
@Component({
  selector: 'app-invoice-update-programado',
  templateUrl: './invoice-update-programado.component.html',
  styleUrls: ['./invoice-update-programado.component.scss']
})
export class InvoiceUpdateProgramadoComponent implements OnInit {

  invoice: Invoice;
  errors: any[];
  message = "";

  constructor(
      private invoiceService: InvoiceService,
      public ref: DynamicDialogRef,
      public config: DynamicDialogConfig,
      private spinner: NgxSpinnerService,
      private toasty:ToastService,
  ) {
  }

  async getInvoiceFinancesErrorLog() {
    return await this.invoiceService.getInvoiceFinancesErrorLog(this.invoice.id).toPromise();
  }

  async ngOnInit(): Promise<void> {
    this.invoice = this.config.data.invoice;
    try {
      this.errors = await this.getInvoiceFinancesErrorLog();
    } catch (e) {
      // Sem o log de erros o reenvio continua possível; só não há mensagem para mostrar.
      this.errors = [];
    }
    this.message = this.createErrorMessage();
  }

  public closeDialog() {
    this.ref.close();
  }

  async updateLancamentoProgramadoByInvoiceId() {
    this.spinner.show();
    this.invoiceService.updateLancamentoProgramadoByInvoiceId(this.invoice.id).subscribe(
        (data) => {
          this.toasty.success("Fatura enviada para a fila financeiro");
          this.spinner.hide();
          this.closeDialog()
        }, (error) => {
          this.toasty.error("Erro ao enviar fatura para o financeiro");
          this.spinner.hide();
          this.closeDialog()
        });
  }

  createErrorMessage() {
    if(!this.errors || this.errors.length === 0) return;
    const err = this.errors[0];
    const timeEvent = err.timeEvent ? " - " + moment(err.timeEvent).format("DD/MM/YYYY HH:mm:ss") : "";
    return err.errorMessage + timeEvent;
  }

}
